import { FC, useState } from "react";

import FAQCardContent from "./FAQCardContent";
import FAQCard from "./FAQCard";
import { FAQSectionProps } from "../FAQSection.props";
import styles from "../FAQSection.module.scss";

const FAQDesktop: FC<FAQSectionProps> = ({ faqData }: FAQSectionProps) => {
  const [activeFAQItem, setActiveFAQItem] = useState<string>(faqData[0].title);
  const activeFAQContent = faqData.find((faqItem) => faqItem.title === activeFAQItem);

  return (
    <div className={styles.FAQSectionDesktop} data-testid="faq-section-desktop">
      <div className={styles.FAQCardContainer}>
        {faqData.map(({ title, id }, index) => (
          <FAQCard
            key={index}
            isActive={activeFAQItem === title}
            title={title}
            setActiveFAQItem={setActiveFAQItem}
            id={id}
            testId={title}
          />
        ))}
      </div>
      <FAQCardContent {...activeFAQContent} />
    </div>
  );
};

export default FAQDesktop;
